import { createPref } from "./prefs";

export type Theme = "light" | "dark";

const META_COLOR: Record<Theme, string> = { light: "#1c73ad", dark: "#16132b" };

// Light is the default; the toggle in the top bar remembers a change.
export const themePref = createPref<Theme>("dp.theme", () => "light", ["light", "dark"]);

/** Puts the theme on <html> (styles.css keys off data-theme). */
export function applyTheme(theme: Theme = themePref.get()) {
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", META_COLOR[theme]);
}

export function toggleTheme() {
  const next: Theme = themePref.get() === "dark" ? "light" : "dark";
  themePref.set(next);
  applyTheme(next);
}
